import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Match',
  favIconName: 'favicon-match',
  name: 'fantasticllama',
  facebookUrl: '/cp/social/r/facebook.html?lid=4',
  instagramUrl: '/cp/social/r/instagram.html?lid=4',
  twitterUrl: '/cp/social/r/twitter.html?lid=4',
};

export default branding;
